import { render } from "./AlarmsPanel.vue?vue&type=template&id=23b942b4&scoped=true"
import script from "./AlarmsPanel.vue?vue&type=script&lang=js"
export * from "./AlarmsPanel.vue?vue&type=script&lang=js"

import "./AlarmsPanel.vue?vue&type=style&index=0&id=23b942b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b942b4"]])

export default __exports__